import { CircularProgress, CircularProgressProps } from "@mui/material";
import React from "react";

const CircularProgressWrapper: React.FC<CircularProgressProps> = ({ ...props }) => (
  <CircularProgress {...props} />
);

export default CircularProgressWrapper;
